import { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';

/**
 * Returns the contentful data for sweetpass.
 */
export const useSweetpassContent = (content: SweetpassContent | undefined) => {
  const { formatMessage } = useIntl();

  return useMemo(() => {
    const checkoutTitle = content?.checkoutTitle ?? formatMessage(fallbacks.checkoutTitle); // prettier-ignore
    const checkoutHowItWorks = content?.checkoutHowItWorks ?? formatMessage(fallbacks.checkoutHowItWorks); // prettier-ignore
    const checkoutPurchaseCta = content?.checkoutPurchaseCta ?? formatMessage(fallbacks.checkoutPurchaseCta); // prettier-ignore

    return {
      checkoutTitle,
      checkoutHowItWorks,
      checkoutPurchaseCta,
    };
  }, [content, formatMessage]);
};

// ─── Fallbacks ───────────────────────────────────────────────────────────────

const fallbacks = defineMessages({
  checkoutTitle: {
    defaultMessage: 'Purchase your sweetpass',
    description: 'Sweetpass | Checkout | Title',
  },
  checkoutHowItWorks: {
    defaultMessage:
      'For $10, you get $3 off one order a day for the rest of the month. Apply the pass discount to your bag during checkout (it won’t apply on its own). Works for pickup or delivery, as long as your order is $15 or more.',
    description: 'Sweetpass | Checkout | How It Works',
  },
  checkoutPurchaseCta: {
    defaultMessage: 'Buy now for $10',
    description: 'Sweetpass | Checkout | Purchase CTA',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

export type SweetpassContent = {
  checkoutTitle?: string;
  checkoutHowItWorks?: string;
  checkoutPurchaseCta?: string;
};
